import { defineMessages } from 'react-intl';

export const assumptionsMessageDefinitions = defineMessages({
  addButton: {
    id: 'assumptions.addButton',
    defaultMessage: 'Add new assumption',
  },
  listModalTitleWithPhaseNameFormatted: {
    id: 'assumptions.listModal.titleWithPhaseNameFormatted',
    defaultMessage: 'Assumptions for {phaseName}',
  },
  tableHeaderOrder: {
    id: 'assumptions.table.header.order',
    defaultMessage: '#',
  },
  tableHeaderAssumptionId: {
    id: 'assumptions.table.header.assumptionId',
    defaultMessage: 'Assumption ID',
  },
  tableHeaderEstimationItem: {
    id: 'assumptions.table.header.estimationItem',
    defaultMessage: 'Estimation Item',
  },
  tableHeaderAssumptionType: {
    id: 'assumptions.table.header.assumptionType',
    defaultMessage: 'Assumption Type',
  },
  tableHeaderAssumption: {
    id: 'assumptions.table.header.assumption',
    defaultMessage: 'Assumption',
  },
  tableHeaderIsValid: {
    id: 'assumptions.table.header.isValid',
    defaultMessage: 'Active',
  },
  exportTitle: {
    id: 'assumptions.table.export.title',
    defaultMessage: 'Assumptions',
  },
});
